import { EAdvancedFilterLogic } from '../../filters-advanced/models/advanced-filter-logic.enum';
import { getDefaultQuickFilters } from '../../filters/utils/get-default-quick-filters';
import { EDefaultColumnWidths } from '../../site/site-table/columns/default-column-widths-enum';
import { TSingleColumnData } from '../../site/site-table/site-table-columns-data.service';
import { TSavedView } from '../models/saved-view.model';
import { fixViewCustomFields } from './fix-view-custom-fields';

export function fixView({ view }: { view: TSavedView }): TSavedView {
  const newViewWithFixedCfs = fixViewCustomFields(view);
  const newViewWithFlag = addRedFlagIfMissing(newViewWithFixedCfs);
  const newViewWithGrouping = addGroupingInfoIfMissing(newViewWithFlag);
  return addFiltersInfoIfMissing(newViewWithGrouping);
}

function addGroupingInfoIfMissing(newView: TSavedView): TSavedView {
  return {
    ...newView,
    collapsedGroups: newView.collapsedGroups || [],
  };
}

function addRedFlagIfMissing(newView: TSavedView): TSavedView {
  const columns = newView.columns;

  if (!columns.find((column) => column.name === 'Flag')) {
    const redFlagColumnsData: TSingleColumnData = {
      name: 'Flag',
      index: 0,
      hidden: false,
      width: EDefaultColumnWidths.RED_FLAG,
    };

    columns.splice(0, 0, redFlagColumnsData);
  }

  newView.columns = columns.map((column, index) => ({ ...column, index: index }));

  return newView;
}

function addFiltersInfoIfMissing(view: TSavedView): TSavedView {
  const newView = { ...view };

  if (!newView.quickFilters) {
    newView.quickFilters = {
      quick: getDefaultQuickFilters(),
      advanced: {
        filters: [],
        operator: EAdvancedFilterLogic.AND,
      },
    };
  }

  if (!newView.quickFilters.advanced) {
    newView.quickFilters.advanced = {
      filters: [],
      operator: EAdvancedFilterLogic.AND,
    };
  }

  if (!newView.quickFilters.quick) {
    newView.quickFilters.quick = getDefaultQuickFilters();
  }

  return newView;
}
